import React, { Component } from 'react'
import { useQuery } from 'react-query'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import moment from 'moment';
import axios from 'axios';
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance';
import S3FileUpload from 'react-s3';
import swal from '@sweetalert/with-react';

export default class Stage2ViewReviewofAudit extends Component {
    constructor(props) {
        super(props)
        this.state = {
        //   orgCode : props.match.params.orgcode,
        //   stage2reviewofauditUrl: "",

        reportOfreviewProcess: {
            orgCode : props.match.params.orgcode,
            stage2reviewofauditUrl: "",
          
        },
          data: {},
          config: {
            bucketName: process.env.REACT_APP_BUCKET_NAME,
            dirName: process.env.REACT_APP_DIR_NAME /* optional */,
            region: process.env.REACT_APP_REGION,
            accessKeyId: process.env.REACT_APP_ACCESS_ID,
            secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
        },
        buttonStatus: "none",
        downloadbuttonStatus: "none",
        uploadDocumentStatus: "none",
        uploadedDocumentStatus: "none",
        showFile: "Image",
        uploadedProcessUrl: "",
        submitStatus: true,
        messageforvalidation :"none",
        isLoading:false
        }
        this.viewprocessUrlInput = React.createRef();
    }
    static getDerivedStateFromProps(props, state) {
        return { id: props.match.params.orgcode || 0 };
    }
    componentDidMount() {
        const api = APIURL + '/api/stagetwo/get/stagetwodata/' + this.state.reportOfreviewProcess.orgCode
        axios.get(api, {headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token"),
         }})
        .then(res => {
            console.log("data ",res.data.response)
            if (res.data.errorCode === 0) {
                this.setState({ data: res.data.response });
                if ( this.state.data.stage2reviewofauditUrl) {
                    var uplodedFileName= this.state.data.stage2reviewofauditUrl.split("/")
                    var uplodedFileNameToView = uplodedFileName[4]
                    this.setState({ uploadedProcessUrl: this.state.data.stage2reviewofauditUrl })
                    this.setState({ uploadDocumentStatus: "none", uploadedDocumentStatus: "block",downloadbuttonStatus:"none" ,submitStatus : true,uploadedFileNameToshow: uplodedFileNameToView})
                }
                else if (! this.state.data.stage2reviewofauditUrl) {
                    this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none",downloadbuttonStatus:"block" })
                }
             
            }
          })
          .catch(e => {
            console.log("Something went Wrong", e)
            var string = JSON.stringify(e).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);

            console.log("found", found);
            if (found !== null) {
                window.location.href = "/signin"
               // alert("if")
                this.setState({isLoading:true})
            }
        })
          
      }
      handleprocessreview = (event) => {
        event.preventDefault();
        let newArr = this.viewprocessUrlInput.current.files[0];
        this.handleUpload(newArr);
    }
    handleUpload = (file) => {
        var file1 = Math.round((file.size / 1024));
        if(file1 <= 3072 ){
        S3FileUpload
            .uploadFile(file, this.state.config)
            .then(data => {
                console.log("data s3",data)
                var tempData =this.state.reportOfreviewProcess;
                tempData.stage2reviewofauditUrl = data.location
                var file= data.key.split("/")
                var fileName = file[1];
                console.log("fileName",fileName)
                var docType = this.checkFileExtension(data.location)
                this.setState({ stage2reviewofauditUrl: tempData,
                                showFile: docType ,
                                submitStatus : false,
                                messageforvalidation : "none",
                                fileToUpload : data.location,
                                filenameToview : fileName
                            });
            })
            .catch(err => console.error(err))
        }
        else{
            this.setState({messageforvalidation : "block", submitStatus : false,filenameToview : ""})
        }
    }; 

    checkFileExtension = (file) => {
        if (file) {
            if (file.match(/\.(jpg|jpeg|png|gif)$/)) {
                return "Image"
            } else if (file.match(/\.(pdf)$/)) {
                return 'pdf'
            }
        }
    }

    removeDoc = () => {
        var tempData = this.state.reportOfreviewProcess;
        tempData.stage2reviewofauditUrl = ""
        this.setState({  reportOfreviewProcess: tempData ,submitStatus : true});
    }
    removeUplodedDoc = () => {
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    var jsonRequest ={
                        "orgCode":this.state.reportOfreviewProcess.orgCode,
                     
                   }
 
             axios.patch(APIURL + "/api/stagetwo/patch/deletestage2reviewofprocessurl",jsonRequest)
            .then((res) => {
            if (res.data.errorCode === 0) {
            this.setState({
                        uploadDocumentStatus: "block",
                        uploadedDocumentStatus: "none",
                        uploadProcessUrl: "",
                        uploadStatus: true,
                        uploadedProcessUrl: "",
                        editStatus: true
                    })
            }
       else {
           ToastInstance('Error', 'Something Went Wrong')
       }
   })
   .catch(err => {
       ToastInstance('warning', 'Something Went Wrong..Please Try again')
   })
                    this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none", uploadProcessUrl: "" ,submitStatus : true})

                }
            })
    }    
    handleRoute = () => {
        window.location.href = "/"+localStorage.getItem("role")+'/stage2reviewofaudit/' +this.state.reportOfreviewProcess.orgCode;
    }

    generateReviewProcess = () => {
        return axios.get(APIURL+'/api/generatepdf/get/reviewofauditprocess/' + this.state.reportOfreviewProcess.orgCode, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        ) 
            .then((response) => {
              
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = this.state.reportOfreviewProcess.orgCode + '- Review Of Audit' + `.pdf`
                link.click()
            })


    }

    postData = () => {
        var jsonRequest = {
            orgCode: this.state.reportOfreviewProcess.orgCode,
            stage2reviewofauditUrl: this.state.reportOfreviewProcess.stage2reviewofauditUrl,
        }
        console.log("json",jsonRequest)
        axios.patch(APIURL + "/api/stagetwo/patch/stage2reviewofauditurl", jsonRequest)
            .then((res) => {
                if (res.data.errorCode === 0) {
                    ToastInstance('Success', 'Review Audit Process Updated')
                }
                else {
                    ToastInstance('Error', 'Something Went Wrong')
                }
            })
            .catch(err => {
                ToastInstance('warning', 'Something Went Wrong..Please Try again')
            })

    }
    downloadSignedPdf = () => {
        const link = document.createElement('a');
        console.log("link",link)
        link.href = this.state.uploadedProcessUrl
        window.open(link)
      

    }
    downloadUploadPdf=()=>{
        const link = document.createElement('a');
        console.log("link",link)
        link.href = this.state.fileToUpload
        window.open(link)
    }
    render() {
         const FileReviewProcess = () => (
            this.state.showFile === 'Image' ?
                <>
                    <img className="img-fluid" src={this.state.reportOfreviewProcess.stage2reviewofauditUrl} style={{ width: '80px', height: '80px' }} onClick={() => this.downloadUploadPdf()} />
                    <span>
                        <h6 onClick={() => this.removeDoc('stage2reviewofauditUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                    </span>
                </>
                :
                this.state.showFile === 'pdf' ?
                <div className="row">
                    <div className="col-sm-12">
                        <img className="img-fluid" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} onClick={() => this.downloadUploadPdf()} />
                        <span>
                            <h6 onClick={() => this.removeDoc('stage2reviewofauditUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                        </span>
                        </div>
                         <div className="row">
                             <span>{this.state.filenameToview}</span>

                         </div>
                     </div>
                    :
                    <>
                        <input type='file' ref={this.processUrlInput} onChange={this.handleprocessreview} />
                        <p style={{ fontSize: '10px', color: 'red' }}>Only Pdf and images are accpeted</p>
                    </>
        )
        if(this.state.isLoading){
            return(<h1>Loading</h1>)
        }
    return (
        <div>
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">
                  
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card-body" style={{ paddingLeft: "50px" }}>
                                    <div className="row">
                                        <div className="col-sm-12">
                                        
                                                <div className="row">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Name of Audited Organization</label>
                                                    <div className="col-sm-9">
                                                        <p> {this.state.data.orgName}</p>
                                                    </div>
                                                    </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Date(s) of Audit Conducted</label>
                                                    <div className="col-sm-3">
                                                        <p> {moment(this.state.data.dateofaudit).format('DD-MMM-YYYY')}</p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Ref No.</label>
                                                    <div className="col-sm-3">
                                                        <p> {this.state.data.refno}</p>
                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Lead Auditor</label>
                                                    <div className="col-sm-9">
                                                        <p> {this.state.data.teamleaderName}</p>
                                                    </div>
                                                   
                                                </div>
                                                
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Auditor One</label>
                                                    <div className="col-sm-3">
                                                        <p> {!this.state.data.auditorOneName  ? "NA" : this.state.data.auditorOneName}</p>
                                                      
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Auditor Two</label>
                                                    <div className="col-sm-3">
                                                        <p> {!this.state.data.auditorTwoName ? "NA" : this.state.data.auditorTwoName}</p>
                                                      
                                                    </div>
                                                   
                                                </div>
                                                <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-3 labelsize">Type of Audit Imparted.</label>
                                                            <div className="col-sm-9">
                                                            <p> {this.state.data.auditimparted}</p>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-4">
                                                            <label htmlFor="staticEmail" className="col-sm-7 labelsize">Review Acceptance for no Conflict of interest with the above organization.</label>
                                                            <div className="col-sm-3">
                                                            <p> {this.state.data.remarkofstage}</p>
                                                            </div>
                                                        </div>  
                                                <br />
                                                <hr />
                                                  
                                                    <div className="row ">
                                                        <table className="table table-bordered ">
                                                            <thead className="table-primary">
                                                                <tr className="fontcontractviewtable">
                                                                    <th>Sr No</th>
                                                                    <th scope="col" className="text-center" >Review Aspect</th>
                                                                    <th scope="col" className="text-center">Yes/No/NA</th>
                                                                    <th scope="col" className="text-center">Remark/ Details (If any)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                <tr >
                                                                    <td className="text-center" >1</td>
                                                                    <td className="fontcontractviewtable">Contracts have been signed prior to Audit<br/>
                                                                                                         (Applicable to Re-certification/ Transfer Audit….)
                                                                    </td>
                                                                     <td className="text-center"> <p className="mt-4">{this.state.data.conaudittracts}</p> </td>
                                                                        <td> <p className="mt-4">{this.state.data.remarkconaudittracts}</p> </td> 
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">2</td>
                                                                    <td className="fontcontractviewtable">Audit Notification and assignment of auditor sign prior to audit</td>
                                                                    <td className="text-center">  <p className="mt-4">{this.state.data.auditnotification}</p></td>
                                                                        <td> <p className="mt-4">{this.state.data.remarkauditnotification}</p> </td>
                                                                </tr>
                                                             
                                                                <tr>
                                                                    <td className="text-center">3</td>
                                                                    <td className="fontcontractviewtable">Auditor/ Industrial declaration for no conflict of interest has been signed.</td>
                                                                    
                                                                        <td className="text-center"> <p className="mt-4">{this.state.data.leadauditorquali}</p></td>
                                                                        <td> <p className="mt-4">{this.state.data.remarkleadauditorquali}</p></td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">4</td>
                                                                    <td className="fontcontractviewtable">The Lead Auditor (and Technical Expert) is qualified </td>
                                                                    <td className="text-center">  <p className="mt-4">{this.state.data.actiontakenonissues}</p></td>
                                                                    <td> <p className="mt-4">{this.state.data.remarkactiontakenonissues}</p> </td>
                                                                </tr>

                                                                <tr>
                                                                    <td className="text-center">5</td>
                                                                    <td className="fontcontractviewtable">Action taken on the issue/ NC raise if any during IQCPL last periodical audit (like stage 1, surveillance) are verified by LA and Accepted?</td>
                                                                    
                                                                        <td className="text-center">  <p className="mt-4">{this.state.data.auditplansent}</p></td>
                                                                        <td> <p className="mt-4">{this.state.data.remarkauditplansent}</p> </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">6</td>
                                                                    <td className="fontcontractviewtable">The Audit Plan was sent to the client on time and audit conducted as per plan
                                                                    </td>
                                                                    <td className="text-center">  <p className="mt-4">{this.state.data.openingandclosing}</p></td>
                                                                        <td> <p className="mt-4">{this.state.data.remarkopeningandclosing}</p> </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">7</td>
                                                                    <td className="fontcontractviewtable">Opening and closing meeting done as per scheduled time & prompter covered.
                                                                    </td>
                                                                    <td className="text-center"> <p className="mt-4">{this.state.data.auditreportcoverd}</p></td>
                                                                        <td> <p className="mt-4">{this.state.data.remarkauditreportcoverd}</p></td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">8</td>
                                                                    <td className="fontcontractviewtable">The Audit Report covered all the formats as per audit binder</td>

                                                                    <td className="text-center">  <p className="mt-4">{this.state.data.accomplished}</p></td>
                                                                        <td> <p className="mt-4">{this.state.data.remarkaccomplished}</p> </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">9</td>
                                                                    <td className="fontcontractviewtable">Was Audit Plan or (Audit Objective for follow-up audits) was accomplished? (All Audits).
                                                                    </td>
                                                                    <td className="text-center"> <p className="mt-4">{this.state.data.investigation}</p> </td>
                                                                        <td> <p className="mt-4">{this.state.data.remarkinvestigation}</p></td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">10</td>
                                                                    <td className="fontcontractviewtable">Investigation for Corrective/ Preventive Actions is to be satisfactory in case if any “NC”.
                                                                    </td>
                                                                    <td className="text-center">  <p className="mt-4">{this.state.data.responseTocorrectiveaction}</p></td>
                                                                        <td> <p className="mt-4">{this.state.data.remarkresponseTocorrectiveaction}</p> </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">11</td>
                                                                    <td className="fontcontractviewtable">Responses to corrective action requests were received and were approved by Lead Auditor (In case of Follow-up Audit).
                                                                    </td>
                                                                    <td className="text-center">  <p className="mt-4">{this.state.data.noOfsurveillance}</p></td>

                                                                        <td> <p className="mt-4">{this.state.data.remarknoOfsurveillance}</p></td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">12</td>
                                                                    <td className="fontcontractviewtable">No. of Surveillance required are decided by Lead Auditor.
                                                                    </td>
                                                                    <td className="text-center">  <p className="mt-4">{this.state.data.auditSummary}</p></td>
                                                                        <td> <p className="mt-4">{this.state.data.remarkauditSummary}</p> </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">13</td>
                                                                    <td className="fontcontractviewtable">Audit Summary and Recommendation of audit result clearly addressed.
                                                                    </td>
                                                                    <td className="text-center">  <p className="mt-4">{this.state.data.recomendationOfAudit}</p></td>

                                                                        <td> <p className="mt-4">{this.state.data.remarkrecomendationOfAudit}</p></td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">14</td>
                                                                    <td className="fontcontractviewtable">Key processed identified & with production/service provision process audit and audit trail for selected sample covered adequately with recommendation
                                                                    </td>
                                                                    <td className="text-center">  <p className="mt-4">{this.state.data.keyProcess}</p></td>

                                                                        <td> <p className="mt-4">{this.state.data.remarkkeyProcess}</p></td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-center">15</td>
                                                                    <td className="fontcontractviewtable">Non- conformities are corrected by the client and closed-out by Lead Auditor (All Audits). </td>
                                                                    <td className="text-center">  <p className="mt-4">{this.state.data.nonConfrmities}</p></td>

                                                                        <td> <p className="mt-4">{this.state.data.remarknonConfrmities}</p></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <div >
                                                                <div className="row mt-4">
                                                                    <hr className="mt-4" />
                                                                    <div className="col-sm-6 text-dark ">
                                                                        <h5>Download Review Audit Process Report</h5>
                                                                    </div>
                                                                    <div className="col-sm-5 mb-3" style={{textAlign:"right"}}>
                                                                    <button className="btn btn-primary col-sm-3" onClick={() => this.generateReviewProcess()}>Download</button>
                                                                </div>
                                                                    <hr />
                                                                   
                                                                </div>
                                                                </div>   
                                                                {
                                                                        localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ? 
                                                                            ""
                                                                            :
                                                  <div style={{ display: this.state.uploadDocumentStatus }}>
                                               <div className="row mt-4">
                                                   <hr className="mt-4" />
                                                   <div className="col-sm-6 text-dark ">
                                                       <h5>Upload Review Audit Process Report</h5>
                                                   </div>
                                                   <hr />


                                                
                                                       <div className="row mt-5" >
                                                           <div className="col-sm-4"><label htmlFor="staticEmail" className="labelsize">Upload Review Audit Process </label></div>
                                                           <div className="col-sm-6">
                                                           <p style={{color:"red" ,display:this.state.messageforvalidation}}>Please Select Size Which is less than 3 MB</p>
                                                               {
                                                                  this.state.reportOfreviewProcess.stage2reviewofauditUrl !== "" ?
                                                                       <FileReviewProcess />
                                                                       :
                                                                       <>
                                                                           <input type='file' ref={this.viewprocessUrlInput} onChange={this.handleprocessreview} />
                                                                           <br></br>

                                                                       </>
                                                               }
                                                           </div>
                                                           </div>
                                                           <div className="row">
                                                                <div className="col-sm-10" />
                                                                <button type="button" className="btn btn-sm btn-success col-sm-2" onClick={() => this.postData()} disabled={this.state.submitStatus}>Upload</button>

                                                            </div>
                                                        </div>
                                                       </div>
                                                        }
                                                                                     
                                               </div>
                                           

                                           <div style={{ display: this.state.uploadedDocumentStatus }} >
                                                    <div className="row mt-5" >
                                                        <hr className="mt-4" />
                                                        <div className="col-sm-6 text-dark ">
                                                            <h5>Uploaded Review Audit Process</h5>
                                                        </div>
                                                        <hr />
                                                        <div className="col-sm-4">

                                                            <label className="mt-4 labelsize">
                                                                Uploaded Review Audit Process
                                                            </label>

                                                        </div>
                                                        <div className="col-sm-6">
                                                            {
                                                                this.state.uploadedProcessUrl.match(/\.(jpg|jpeg|png|gif)$/) ?
                                                                    <>
                                                                        <img className="img-fluid" src={this.state.uploadedProcessUrl} style={{ width: '80px', height: '80px' }} onClick={()=>this.downloadSignedPdf()}/>
                                                                        <p>{this.state.uploadedFileNameToshow}</p>
                                                                        {
                                                                        localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts'?
                                                                        ""
                                                                        :
                                                                        <span>
                                                                            <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                        </span>
                                                                          
                                                                        }
                                                                        
                                                                    </>
                                                                    :
                                                                    this.state.uploadedProcessUrl.match(/\.(pdf)$/) ?
                                                                        <>
                                                                            <img className="img-fluid mt-3" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }}  onClick={()=>this.downloadSignedPdf()}/>
                                                                            {
                                                                        localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts'?
                                                                        ""
                                                                        :
                                                                        <span>
                                                                            <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                        </span>
                                                                        }
                                                                        <p>{this.state.uploadedFileNameToshow}</p>
                                                                        </>

                                                                        :
                                                                        ""
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                      localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ? 
                                                      
                                                      !this.state.uploadedProcessUrl  ?
                                                      <>
                                                     
                                                     
                                                         <div className="col-sm-6">The Signed Pdf is not yet uploaded</div>
                                                             
                                                               </> 
                                                                
                                                                :
                                                                ""
                                                                :
                                                                ""

                                                }
                                          
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div className="card-footer">
            { 
                                localStorage.getItem("userRole")==="Management" || localStorage.getItem("userRole")==="Accounts" ?
                                ""
                                :
                                <div className="row">
                                <div className="col-lg-11"></div>
                                <div className="col-lg-1" style={{ marginBottom: "10PX" }}>

                                    <button type="submit" className="btn btn-primary" onClick={() => this.handleRoute()}>Edit</button>

                                </div>
                            </div>
                 }
            </div>
        </div>
    )
}
}